/* eslint-disable no-plusplus */

const units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

/**
 * @param {string} size size in bytes, e.g. 50000000, to be converted
 * @returns {string} String
 *
 * @description This solution was found on stackoverflow:
 * @link https://stackoverflow.com/a/39906526
 */
export function niceBytes(size: number): string {
    let l = 0,
        n = parseInt(String(size), 10) || 0;

    while (n >= 1024 && ++l) {
        n = n / 1024;
    }

    return `${n.toFixed(n < 10 && l > 0 ? 1 : 0)} ${units[l]}`;
}
